import { Field } from "formik";
import React from "react";

export const CheckBox = ({
  name,
  handleChange,
  propName,
  isChecked,
  onSeperateLine,
  pTop,
  pBottom,
}) => {
  return (
    <div
      className={`subscription-plan-list-element ${
        onSeperateLine ? "d-block" : ""
      }
      ${pTop ? `pt-${pTop}` : ""}
      ${pBottom ? `pb-${pBottom}` : ""}
      
      `}
    >
      <div className="selction-box mt-0 px-0 mr-3">
        <div className="time-select-box d-inline-block"></div>
        <div className="d-flex align-items-center">
          <div className="checkboxes-list form-check">
            <label
              className={`container-blk form-check-label max-width-fit-content`}
              for={propName}
              style={{ maxWidth: "100% !important" }}
            >
              <Field
                className="form-check-input"
                type="checkbox"
                name={propName}
                id={propName}
                value={true}
                checked={isChecked}
                onChange={handleChange}
              />
              <span class="checkmark"></span>
              <span className="h4">{name}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
